export const PATHS = {
  HOME: "/",
  PROFILE: "/myprofile",
  BACKUP: "/backup",
  PAYMENTS: "/payments",

};
